import axios from "axios"
import { queryFixer } from "common/utils/utils"

const AlbaranService = {
  async importarEDI(file: $TSMigrationFixMe) {
    return axios.post("/Albaran/import-edi", file)
  },
  async getEdiFromAlbaran(id: $TSMigrationFixMe, formato: $TSMigrationFixMe) {
    return axios.get(`/Albaran/export-edi/${id}/formato/${formato}`, {
      responseType: "blob",
    })
  },

  getArchivosAdjuntosById(id: $TSMigrationFixMe) {
    return axios.get(`/Albaran/${id}/ficheros-adjuntos`)
  },

  getDocumentosAsociadosById(id: $TSMigrationFixMe) {
    return axios.get(`/Albaran/${id}/documentos-asociados`)
  },

  addNewArchivoAdjunto(albaranID: $TSMigrationFixMe, file: $TSMigrationFixMe) {
    return axios.post(`/Albaran/${albaranID}/add-fichero-adjunto`, file)
  },

  deleteArchivoAdjunto(
    albaranID: $TSMigrationFixMe,
    fileID: $TSMigrationFixMe
  ) {
    return axios.delete(`/Albaran/${albaranID}/fichero/${fileID}`)
  },

  getPdfById(id: $TSMigrationFixMe) {
    return axios.get(`/Albaran/${id}/pdf`, {
      responseType: "blob",
    })
  },

  getById(id: $TSMigrationFixMe) {
    return axios.get(`/Albaran/${id}`)
  },

  archivosGetById(id: $TSMigrationFixMe) {
    return axios.get(`/Albaran/${id}/ficheros-adjuntos`)
  },

  getAlbaranesWithSameLibradoLibrador({
    libradorId,
    libradoId,
    ...filters
  }: $TSMigrationFixMe) {
    return axios.get("/Albaran/by-filters", {
      params: {
        ...filters,
        libradoId,
        libradorId,
      },
    })
  },
  getAlbaranByMsgEncrypted({ msgEncrypted }: $TSMigrationFixMe) {
    const query = queryFixer(
      `/Albaran/by-filters-encrypted?MsgEncrypted=${msgEncrypted}`
    )
    return axios.get(query)
  },

  getAlbaranesEnviados({ libradorId, queryState }: $TSMigrationFixMe) {
    const query = queryFixer(
      `/Albaran/by-filters?libradorId=${libradorId}`,
      queryState
    )
    return axios.get(query)
  },

  getAlbaranesRecibidos({ libradoId, queryState }: $TSMigrationFixMe) {
    const query = queryFixer(
      `/Albaran/by-filters?libradoId=${libradoId}`,
      queryState
    )
    return axios.get(query)
  },

  changeEstado({
    documentoId,
    estadoRevisionDocumento,
    motivo,
  }: $TSMigrationFixMe) {
    return axios.put("/Albaran/change-estado", {
      documentoId,
      estadoRevisionDocumento,
      motivo: motivo?.length ? motivo : null,
    })
  },

  changeMultipleEstados({
    documentosId = [],
    estadoRevisionDocumento,
    motivo,
  }: $TSMigrationFixMe) {
    return axios.put("/Albaran/bulk-change-estado", {
      documentosId,
      estadoRevisionDocumento,
      motivo: motivo?.length ? motivo : null,
    })
  },
  getDocumentosPendientesValidar(queryParam: $TSMigrationFixMe) {
    return axios.get(`/Albaran/pendientes-firmar${queryParam}`)
  },
  getDocumentoPendienteValidacion(id: $TSMigrationFixMe) {
    return axios.get(`/Albaran/${id}/validacion`)
  },
  validateDocumentoPendiente(id: $TSMigrationFixMe, data: $TSMigrationFixMe) {
    return axios.post(`/Albaran/${id}/aprobacion`, data)
  },
}

export default AlbaranService
